export const homeContent = {
    fr: {
        badge: 'IPTV Premium · Activation en minutes',
        titleLine1: 'Tout votre divertissement,',
        titleLine2: 'réuni ',
        titleGradient: 'en un seul écran.',
        subtitle: 'Profitez de la télévision en direct, du sport, des films et des séries au même endroit, avec une expérience rapide, stable et compatible avec tous vos appareils.',
        ctaOffers: 'Voir les offres',
        ctaSport: 'Voir le sport',
        activationBadge: 'Activation immédiate',
        qualityBadge: '4K · 8K ULTRA HD',
        liveNow: 'En direct maintenant',
        liveChannels: '79 000+ chaînes actives',
    },
    es: {
        badge: 'IPTV Premium · Activación en minutos',
        titleLine1: 'Todo tu entretenimiento,',
        titleLine2: 'reunido ',
        titleGradient: 'en una sola pantalla.',
        subtitle: 'Disfruta de la televisión en directo, el deporte, las películas y las series en un mismo lugar, con una experiencia rápida, estable y compatible con todos tus dispositivos.',
        ctaOffers: 'Ver las ofertas',
        ctaSport: 'Ver el deporte',
        activationBadge: 'Activación inmediata',
        qualityBadge: '4K · 8K ULTRA HD',
        liveNow: 'En directo ahora',
        liveChannels: '+79.000 canales activos',
    },
};
